<template>
  <!--Add Page Container-->
  <div>
    <div class="wrapper" v-if="!this.showDashBoard && this.cropWiseModeEnabled">
      <div class="form-signin">
        <div>
          <h2 class="form-signin-heading">Sign in with</h2>
          <button
            class="btn btn-link w-100 btn-nk-login"
            width="144px"
            v-on:click="authWith('azure')"
          >
            NK Account
          </button>
          <label class="or-label">Or</label>
            <button
              class="btn btn-link w-100  btn-nk-login"
              width="144px"
            v-on:click="authWith('cw')"
          > Cropwise Account</button>
          <p  class="cropwise-login">For legacy users, sign in using NK Account. for Cropwise Imagery users, sign in with Cropwise Account.</p>
        </div>
      </div>
    <footer>
    </footer>
    </div>

    <DashboardMain :user="user" v-if="this.showDashBoard"></DashboardMain>

    <Footer v-if="this.showDashBoard" :isDefaultStyle="this.showDashBoard ? true : false"></Footer>
  </div>
</template>

<script>
import DashboardMain from "../dashboard/DashboardMain.vue";
import Footer from "./Footer.vue";
import initAuthService from "../../services/authenticationServiceInstance";
import Vue from "vue";
import StorageService from "../../services/storageService";
import SubsectionStyles from "../../Styles/subsectionStyles";
import themes_config from "../../../themes.config";
import UtilityService from "../../services/utiliyService";

let utilityService = new UtilityService();
let storageService = new StorageService();

export default {
  components: {
    DashboardMain,
    Footer,
  },
  name: "Home",
  computed: {},
  methods: {
    authWith(authMode) {
      let that = this;
      let storedAuthMode = storageService.get("auth_mode");

      Vue.prototype.$AuthService = initAuthService(authMode);

      if(!storedAuthMode){
        that.login();
      }

      storageService.set("auth_mode", authMode);
      
      this.$AuthService.completeAuthentication().then(() => {
        if (that.$router.currentRoute.fullPath !== "/")
          that.$router.replace("/");

        that.setUser();
      });
    },
    login() {
      this.$AuthService.login();
    },
    setUser() {
      let that = this;
      that.$AuthService.getUser().then((user) => {
        if (!user) that.login();
        else {
          that.user = user;
          that.user.name = user.profile.name;
          that.showDashBoard = true;
        }
      });
    },
    setStyles() {
      let that = this;
      let currentDomain = utilityService.getDomain();
      for (let theme in themes_config) {
        if (themes_config[theme].findIndex((x) => x === currentDomain) != -1) {
          that.$store.commit("setStyle", {
            style: SubsectionStyles[theme],
          });
          window.document.title = SubsectionStyles[theme]["--page_title"]; //'xxxx';
        }
      }
    },
  },
  data() {
    return {
      showDashBoard: false,
      user: null,
      cropWiseModeEnabled : JSON.parse(process.env.VUE_APP_CROPWISE_ENABLED)
    };
  },
  created: function () {
    let that = this;
    let authMode = that.cropWiseModeEnabled ?  storageService.get("auth_mode") : 'azure';

    
    if (authMode && that.$router.currentRoute.fullPath !== "/") {
      this.authWith(authMode);
    }else if (authMode){
       Vue.prototype.$AuthService = initAuthService(authMode);
       that.setUser();

    }

    this.setStyles();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped  lang="scss">
footer{
  background: url("./../../assets/images/login-footer.png") no-repeat;
  padding: 3rem !important;
}
.btn-nk-login{
  font-size: 20px;
  font-weight: bold;
  color: #010066;
  text-decoration: none;
}
.syng-login{
  background: none !important;
  padding: 0rem !important;
  margin-bottom: 5px;
  text-decoration: underline;
  font-size: 12px;
}
.login-cont {
  width: 50%;
  align-content: center;
  margin: 10% 25%;
}

.or-label {
  color: #010066;
  font-weight: bold;
  text-align: center;
  margin: 0;
  border-radius: 50%;
  background: #fff;
  width: 50px;
  height: 50px;
  position: absolute;
  top: 41%;
  transform: translate(-50%);
  left: 50%;
  line-height: 50px;
}

.btn-primary {
  border-radius: 4px;
  width: 100%;
  height: 40px;
  margin: 10px 0;
  border: 1px solid rgb(20, 128, 60);
  background-color: rgb(20, 128, 60);
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: rgb(255, 255, 255);
  float: right;
}

.btn-link {
  img {
    height: 48px;
  }
}

.form-signin-heading {
  color: #00004B;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 17px;
  letter-spacing: -0.0075em;
  line-height: 28px;
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translate(-50%);
}

.input-cont {
  background-color: rgb(243, 244, 246);
  border: 1px solid rgb(194, 199, 208);
  box-sizing: border-box;
  border-radius: 4px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  margin: 2px 0px 5px;
  height: 40px;
  color: rgb(20, 21, 28);
}

.form-signin a {
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 20 px;
  color: rgb(20, 128, 60);
  text-decoration: underline;
  margin-left: 0.2 vw;
  float: right;
}
body {
  background: #eee !important;
}

.wrapper {
  height: 100vh;
  width: 100vw;
  background-size: cover;
  background-color: rgb(245, 248, 252);
}

.form-signin {
  max-width: 380px;
  margin: 0 auto;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 30%;
}

.btn-link {
  padding: 2rem;
  &:first-of-type {
    background: #edeff2;
  }
}

.cropwise-login {
  line-height: 18px;
  font-size: 12px;
  font-weight: 500;
  position: absolute;
  bottom: -64px;
  color:#00004B;
}
</style>
